import BrandMarkSVG from "../icons/BrandMarkSVG.tsx";

const GlobalLoadPage = () => {
    return (
        <div
            className="flex flex-col items-center justify-center h-screen gap-8"
            style={{background: "var(--an-gradient-hero)"}}
        >
            <div className="an-shape an-shape-shadow--hero  px-12 py-8">
                <BrandMarkSVG className="block h-24 w-auto"/>
            </div>
            <div className="flex gap-2">
                <span className="block w-2 h-2 rounded-full bg-an-surface/80 animate-bounce" style={{animationDelay: "0ms"}}/>
                <span className="block w-2 h-2 rounded-full bg-an-surface/80 animate-bounce" style={{animationDelay: "150ms"}}/>
                <span className="block w-2 h-2 rounded-full bg-an-surface/80 animate-bounce" style={{animationDelay: "300ms"}}/>
            </div>
        </div>
    );
};

export default GlobalLoadPage;
